import { render, staticRenderFns } from "./edit-dnd-dialog.vue?vue&type=template&id=5021b7b7&scoped=true&"
import script from "./edit-dnd-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-dnd-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021b7b7",
  null
  
)

export default component.exports